<template>
    <v-data-table v-bind="{ items, headers }" mobile-breakpoint="10000" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined" style="flex: 1 0 auto; position: relative">
        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value)" /> </template>
    </v-data-table>
</template>

<script>
import { initDataTableHeaders, initManufacturingMaterial } from "@/assets/variables";

export default {
    props: {
        material: { type: Object, default: initManufacturingMaterial },
    },
    computed: {
        headers() {
            const headers = [
                { text: "자재설명", value: "name" },
                { text: "상세설명", value: "desc" },
            ];

            const keys = Object.keys(this.items[0] || {}).filter((key) => !headers.map(({ value }) => value).includes(key));

            headers.push(...keys.map((value) => ({ text: value, value })));

            return initDataTableHeaders(headers);
        },
        items() {
            const { name, desc } = this.material;
            return [{ name, desc, ...this.material?.meta?.vendor }];
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-data-table__mobile-row {
        padding: 4px 16px !important;
        &,
        & * {
            height: auto !important;
            min-height: auto;
            font-size: 12px;
            font-weight: normal;
            white-space: pre-line;
        }
        &:first-child {
            margin-top: 12px;
        }
        &:last-child {
            margin-bottom: 12px;
        }
    }
}
</style>
